(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.VaultRules=api;})(typeof globalThis!=='undefined'?globalThis:this,function(){
 'use strict';
 const heights=[1,2,4];
 const types=['Drawers','Sustainers'];
 const layouts={S:['S'],M:['M'],L:['L'],XL:['XL'],SS:['S','S'],SM:['S','M']};
 const patterns={1:[[1]],2:[[2],[1,1]],4:[[4],[2,2],[1,1,1,1],[2,1,1],[1,1,2]]};
 function allowedLayouts(base){return base?({S:['S'],M:['M'],L:['L','SS'],XL:['XL','SM']}[base]||[]):['S','M','L','XL'];}
 function allowedHeights(layout){return layout==='XL'?[1]:heights;}
 function allowedPatterns(type,height){return type==='Sustainers'?(heights.includes(height)?[[height]]:[]):(patterns[height]||[]);}
 function validateLayer(layer,base){
  if(!layer||!types.includes(layer.type)||!allowedLayouts(base).includes(layer.layout)||!allowedHeights(layer.layout).includes(layer.height))return false;
  const families=layouts[layer.layout];
  return Array.isArray(layer.facades)&&layer.facades.length===families.length&&layer.facades.every(pattern=>allowedPatterns(layer.type,layer.height).some(p=>JSON.stringify(p)===JSON.stringify(pattern)));
 }
 function validateBuild(layers){return Array.isArray(layers)&&layers.every((layer,i)=>validateLayer(layer,i?layers[0].layout:null));}
 function totalHeight(layers){return layers.reduce((sum,layer)=>sum+layer.height,0);}
 function partsList(layers){
  const modules=new Map(),facades=new Map();
  function add(map,type,family,height){const key=[type,family,height].join(':');if(!map.has(key))map.set(key,{type,family,height,quantity:0});map.get(key).quantity++;}
  layers.forEach(layer=>layouts[layer.layout].forEach((family,i)=>{
   add(modules,layer.type,family,layer.height);
   layer.facades[i].forEach(height=>add(facades,layer.type,family,height));
  }));
  const order={S:0,M:1,L:2,XL:3};
  const sorted=map=>[...map.values()].sort((a,b)=>types.indexOf(a.type)-types.indexOf(b.type)||order[a.family]-order[b.family]||a.height-b.height);
  const sum=map=>[...map.values()].reduce((n,item)=>n+item.quantity,0);
  return {modules:sorted(modules),facades:sorted(facades),moduleCount:sum(modules),facadeCount:sum(facades),layerCount:layers.length};
 }
 function insert(layers,index,layer){const next=layers.slice();next.splice(index,0,layer);return next;}
 function remove(layers,index){return layers.filter((_,i)=>i!==index);}
 function move(layers,index,delta){const target=index+delta;if(target<0||target>=layers.length)return null;const next=layers.slice();[next[index],next[target]]=[next[target],next[index]];return next;}
 return {heights,types,layouts,patterns,allowedLayouts,allowedHeights,allowedPatterns,validateLayer,validateBuild,totalHeight,partsList,insert,remove,move};
});
